import { Container } from "../components/container";
import { Carousel, CarouselImage } from "./carousel";

const BUCKET_BASE_URL = process.env.BUCKET_BASE_URL || "assets";

const GULDTORGET_IMAGES: CarouselImage[] = [
  {
    src: `${BUCKET_BASE_URL}/portfolio/guldtorget/1_Illustrationsplan_Guldtorget.jpg`,
    alt: "illustration",
  },
  {
    src: `${BUCKET_BASE_URL}/portfolio/guldtorget/2_Sektion-Guldtorget.jpg`,
    alt: "sektion",
  },
  {
    src: `${BUCKET_BASE_URL}/portfolio/guldtorget/3_Perspektiv_guldtorget.jpg`,
    alt: "perspektiv",
  },
];

const KRAKBERGSPARKEN_IMAGES: CarouselImage[] = [
  {
    src: `${BUCKET_BASE_URL}/portfolio/krakbergsparken/1_Kråkbergsparken_1.jpg`,
    alt: "illustration",
  },
  {
    src: `${BUCKET_BASE_URL}/portfolio/krakbergsparken/2_Kråkbergsparken_3.jpg`,
    alt: "illustration",
  },
  {
    src: `${BUCKET_BASE_URL}/portfolio/krakbergsparken/3_thumbnail_IMG_3465.jpg`,
    alt: "illustration",
  },
  {
    src: `${BUCKET_BASE_URL}/portfolio/krakbergsparken/4_Kråkbergsparken_2.jpg`,
    alt: "illustration",
  },
];

const FAGELSANGSPARKEN_IMAGES: CarouselImage[] = [
  {
    src: `${BUCKET_BASE_URL}/portfolio/fagelsangsparken/1_Fågelsångsparken_1.jpg`,
    alt: "illustration",
  },
  {
    src: `${BUCKET_BASE_URL}/portfolio/fagelsangsparken/2_Fågelsångsparken_2.jpg`,
    alt: "illustration",
  },
  {
    src: `${BUCKET_BASE_URL}/portfolio/fagelsangsparken/3_thumbnail_IMG_6727.jpg`,
    alt: "illustration",
  },
  {
    src: `${BUCKET_BASE_URL}/portfolio/fagelsangsparken/4_thumbnail_IMG_6735.jpg`,
    alt: "illustration",
  },
];

export function Portfolio() {
  return (
    <div id="portfolio">
      <Container className="min-h-dvh pt-[195px]">
        <Carousel className="h-[calc(100dvh-250px)]" images={GULDTORGET_IMAGES}>
          <div>
            <H2>GULDTORGET</H2>
            <P>
              Guldtorgets stora planteringsytor skapar långa sträckor av sidor
              att befolkas. Sidorna – kantzonerna där man kan sitta och se allt
              men ändå ha en rygg bakom sig – varierar i utryck och form för att
              alla ska kunna hitta just sin plats. Det finns intima sittplatser,
              öppna sittplatser, sittplatser för stora sällskap, lekfulla
              sittplatser samt traditionella parkbänkar. Guldtorget förblir ett
              grönt torg men istället med en grönska som nu är koncentrerad. På
              så sätt kan en stor torgyta få plats – likväl som flertalet små –
              intima och småskaliga – som fylls med aktivitet och lekytor.
              Guldtorget en ständigt aktiv plats för liv och rörelse – även de
              dagar när ingen marknad eller firande sker.
            </P>
            <P>
              Ingen är bortglömd på Skellefteås nya torg, ingen sida förbisedd.
            </P>
            <p>
              Plats: Skellefteå
              <br />
              Program: Tävlingsförslag öppen tävling
              <br />
              År: 2025
              <br />
              Samarbeten: Studio Hast
            </p>
          </div>
        </Carousel>
      </Container>
      <Container className="min-h-dvh pt-[195px]">
        <Carousel
          className="h-[calc(100dvh-250px)]"
          images={KRAKBERGSPARKEN_IMAGES}
        >
          <div>
            <H2>KRÅKBERGSPARKEN</H2>
            <P>
              Kråkbergsparken är en aktivitetspark för alla åldrar i närområdet
              där naturmarken integrerats in på ett naturligt sätt. Parkens
              mittpunkt är en hexagongunga, omgiven av en trämur som fungerar
              både som skydd och sittbänk. Intill finns småbarnslek med lekhus,
              snurrkoppar, sandlåda och ett trädäck för rollek. En slingrande
              gångväg tar besökare vidare till naturmarken med linbana, lektorn,
              bred rutschkana samt fantasifulla inslag som träkantareller och
              musikinstrument.
            </P>
            <P>
              Parken har upphöjda planteringar med träd, buskar och perenner,
              samt bänkar och grillplats. En pergola ger regnskydd och
              sittplatser finns även längs gångvägarna. Belysningen är gestaltad
              med stor omsorg. I parken finns också konstverket “Clownen i oss”
              av Johan Ferner Ström, placerat i en konstgräsyta. Verket är
              integrerat i lekmiljön och belyses kvällstid.
            </P>
            <P>
              Gestaltat och projekterat under anställning vid Pontarius AB i
              fint sammarbete med Linda Kullänger.
            </P>
            <p>
              Plats: Åkersberga
              <br />
              Beställare: Österåkers kommun
              <br />
              År: 2020-2021, byggt 2023
              <br />
              Samarbeten: Michael Hallbert, Johan Ferner Ström
            </p>
          </div>
        </Carousel>
      </Container>
      <Container className="min-h-dvh pt-[195px]">
        <Carousel
          className="h-[calc(100dvh-250px)]"
          images={FAGELSANGSPARKEN_IMAGES}
        >
          <div>
            <H2>FÅGELSÅNGSPARKEN</H2>
            <P>
              Fågelsångsparken är en nyrenoverad stadsdelspark som binder samman
              närliggande bostadsområden med centrum och erbjuder en grön, trygg
              och aktiv mötesplats för alla åldrar.
            </P>
            <P>
              Parken har fått en stor och varierad lekplats som utformats för
              att passa en bred målgrupp. Flera delar, som sandlådan och trappan
              till rutschkanan, har specialritats för att passa platsens
              förutsättningar. Utformningen av parken präglas av omsorgsfull
              materialhantering och tydlig formgivning. Svart har använts som
              basfärg för parkens utrustning och detaljer – som pergola,
              belysning, cykelställ och inspringningsskydd – vilket kontrasteras
              med cortenstål, trä, storgatsten, corkeen-fallskydd och träflis.
            </P>
            <P>
              För att skapa en hållbar och skötsel­ effektiv park har robusta
              material valts, som stenmjöl i gångytor och planteringsskydd i
              metall. Återanvända massor från platsen har använts till att skapa
              kullar i lekområdet. Parken är tillgänglighetsanpassad, tryggt
              belyst och anlagd med låg underhållsnivå i åtanke.
            </P>
            <P>
              Gestaltat och projekterat under anställning vid Pontarius AB i
              fint sammarbete med Linda Kullänger.
            </P>
            <p>
              Plats: Sollentuna
              <br />
              Beställare: Solentuna kommun
              <br />
              År: 2021, byggt 2022
            </p>
          </div>
        </Carousel>
      </Container>
    </div>
  );
}

function H2({ children }: { children: React.ReactNode }) {
  return (
    <h2 className="mb-5 text-2xl font-[agency-fb] uppercase">{children}</h2>
  );
}

function P({ children }: { children: React.ReactNode }) {
  return <p className="mb-5">{children}</p>;
}
